export const CODIGOS_OCORRENCIA = [
  { label: '000 - Processo de Transporte já Iniciado', value: '000' },
  { label: '001 - Entrega Realizada Normalmente', value: '001' },
  { label: '002 - Entrega Fora da Data Programada', value: '002' },
  { label: '003 - Recusa por Falta de Pedido de Compra', value: '003' },
  { label: '004 - Recusa por Pedido de Compra Cancelado', value: '004' },
  { label: '005 - Falta de Espaço Físico no Depósito do Cliente Destino', value: '005' },
  { label: '006 - Endereço do Cliente Destino não Localizado', value: '006' },
  { label: '007 - Devolução não Autorizada pelo Cliente', value: '007' },
  { label: '008 - Preço Mercadoria em Desacordo com o Pedido Compra', value: '008' },
  { label: '009 - Mercadoria em Desacordo com o Pedido Compra', value: '009' },
  { label: '010 - Cliente Destino somente Recebe Mercadoria com Frete Pago', value: '010' },
  { label: '011 - Recusa por Deficiência Embalagem Mercadoria', value: '011' },
  { label: '012 - Redespacho não Indicado', value: '012' },
  { label: '013 - Transportadora não Atende a Cidade do Cliente Destino', value: '013' },
  { label: '014 - Mercadoria Sinistrada', value: '014' },
  { label: '015 - Embalagem Sinistrada', value: '015' },
  { label: '016 - Pedido de Compras em Duplicidade', value: '016' },
  { label: '017 - Mercadoria fora da Embalagem de Atacadista', value: '017' },
  { label: '018 - Mercadorias Trocadas', value: '018' },
  { label: '019 - Reentrega Solicitada pelo Cliente', value: '019' },
  { label: '020 - Entrega Prejudicada por Horário/Falta de Tempo Hábil', value: '020' },
  { label: '021 - Estabelecimento Fechado', value: '021' },
  { label: '022 - Reentrega sem Cobrança do Cliente', value: '022' },
  { label: '023 - Extravio de Mercadoria em Trânsito', value: '023' },
  { label: '024 - Mercadoria Reentregue ao Cliente Destino', value: '024' },
  { label: '025 - Mercadoria Devolvida ao Cliente de Origem', value: '025' },
  { label: '026 - Nota Fiscal Retida pela Fiscalização', value: '026' },
  { label: '027 - Roubo de Carga', value: '027' },
  { label: '028 - Mercadoria Retida até Segunda Ordem', value: '028' },
  { label: '029 - Cliente Retira Mercadoria na Transportadora', value: '029' },
  { label: '030 - Problema com a Documentação (Nota Fiscal e/ou CTRC)', value: '030' },
  { label: '031 - Entrega com Indenização Efetuada', value: '031' },
  { label: '032 - Falta com Solicitação de Reposição', value: '032' },
  { label: '033 - Falta com Busca/Reconferência', value: '033' },
  { label: '034 - Cliente Fechado para Balanço', value: '034' },
  { label: '035 - Quantidade de Produto em Desacordo (Nota Fiscal e/ou Pedido)', value: '035' },
  { label: '036 - Extravio de documentos pela Cia. Aérea - Cód. Aéreo', value: '036' },
  { label: '037 - Extravio de carga pela Cia. Aérea - Cód. Aéreo', value: '037' },
  { label: '039 - Corte de carga na pista - Cód. Aéreo', value: '039' },
  { label: '040 - Aeroporto fechado na origem - Cód. Aéreo', value: '040' },
  { label: '041 - Pedido de Compra Incompleto', value: '041' },
  { label: '042 - Nota Fiscal com Produtos de Setores Diferentes', value: '042' },
  { label: '043 - Feriado Local/Nacional', value: '043' },
  { label: '044 - Excesso de Veículos', value: '044' },
  { label: '045 - Cliente Destino Encerrou Atividades', value: '045' },
  { label: '046 - Responsável de Recebimento Ausente', value: '046' },
  { label: '047 - Cliente Destino em Greve', value: '047' },
  { label: '048 - Aeroporto fechado no destino - Cód. Aéreo', value: '048' },
  { label: '049 - Vôo cancelado - Cód. Transp. Aéreo', value: '049' },
  { label: '050 - Greve nacional (Greve Geral)', value: '050' },
  { label: '051 - Mercadoria Vencida (Data de Validade Expirada)', value: '051' },
  { label: '052 - Mercadoria Redespachada (Entregue para Redespacho)', value: '052' },
  { label: '053 - Mercadoria não foi Embarcada, Permanecendo na Origem', value: '053' },
  { label: '054 - Mercadoria Embarcada sem CTRC ou CTRC não Embarcado', value: '054' },
  { label: '055 - Endereço Transp. de Redespacho não localizado/não informado', value: '055' },
  { label: '056 - Cliente não Aceita Mercadoria com Pagamento de Reembolso', value: '056' },
  { label: '057 - Transp. não atende a cidade da transportadora de redespacho', value: '057' },
  { label: '058 - Quebra do Veiculo de Entrega', value: '058' },
  { label: '059 - Cliente sem Verba para Pagar o Frete', value: '059' },
  { label: '060 - Endereço de Entrega Errado', value: '060' },
  { label: '061 - Cliente sem Verba para Reembolso', value: '061' },
  { label: '062 - Recusa da Carga por Valor de Frete Errado', value: '062' },
  { label: '063 - Identificação do Cliente não Informada/Enviada/Insuficiente', value: '063' },
  { label: '064 - Cliente não Identificado/Cadastrado', value: '064' },
  { label: '065 - Entrar em Contato com o Comprador', value: '065' },
  { label: '066 - Troca não Disponível', value: '066' },
  { label: '067 - Fins Estatísticos', value: '067' },
  { label: '068 - Data de Entrega Diferente do Pedido', value: '068' },
  { label: '069 - Substituição Tributária', value: '069' },
  { label: '070 - Sistema Fora do Ar', value: '070' },
  { label: '071 - Cliente Destino não Recebe Pedido Parcial', value: '071' },
  { label: '072 - Cliente Destino só Recebe Pedido Parcial', value: '072' },
  { label: '073 - Redespacho somente com Frete Pago', value: '073' },
  { label: '074 - Funcionário não autorizado a Receber Mercadorias', value: '074' },
  { label: '075 - Mercadoria Embarcada para Rota Indevida', value: '075' },
  { label: '076 - Estrada/Entrada de Acesso Interditada', value: '076' },
  { label: '077 - Cliente Destino Mudou de Endereço', value: '077' },
  { label: '078 - Avaria Total', value: '078' },
  { label: '079 - Avaria Parcial', value: '079' },
  { label: '080 - Extravio Total', value: '080' },
  { label: '081 - Extravio Parcial', value: '081' },
  { label: '082 - Sobra de Mercadoria sem Nota Fiscal', value: '082' },
  { label: '083 - Mercadoria em poder da SUFRAMA para Internação', value: '083' },
  { label: '084 - Mercadoria Retirada para Conferência', value: '084' },
  { label: '085 - Apreensão Fiscal da Mercadoria', value: '085' },
  { label: '086 - Excesso de Carga/Peso', value: '086' },
  { label: '087 - Férias Coletivas', value: '087' },
  { label: '088 - Recusado, aguardando negociação', value: '088' },
  { label: '089 - Aguardando refaturamento das mercadorias', value: '089' },
  { label: '090 - Recusado pelo Redespachante', value: '090' },
  { label: '091 - Entrega Programada', value: '091' },
  { label: '092 - Problemas Fiscais', value: '092' },
  { label: '093 - Aguardando carta de correção', value: '093' },
  { label: '094 - Recusa por divergência nas condições de pagamento', value: '094' },
  { label: '095 - Carga aguardando vôo conexão - Cód. Transp. Aéreo', value: '095' },
  { label: '096 - Carga sem embalagem própria para transp. Aéreo - Cód. Aéreo', value: '096' },
  { label: '097 - Carga com dimensão superior ao porão da aeronave - Cód. Aéreo', value: '097' },
  { label: '098 - Chegada na cidade ou filial de destino', value: '098' },
  { label: '099 - Outros tipos de ocorrências não especificados acima', value: '099' },
  { label: '100 - Devolução por não cumprimento do agendamento', value: '100' },
  { label: '101 - Devolução/não entrega a pedido do embarcador', value: '101' },
  { label: '102 - Devolução/não entrega a pedido do destinatário', value: '102' },
  { label: '103 - Devolução/não entrega a pedido transportadora de redespacho', value: '103' },
  { label: '104 - Entrega efetuada na Transportadora de Redespacho', value: '104' },
  { label: '105 - Entrega efetuada no cliente pela Transportadora de Redespacho', value: '105' },
  { label: '201 - Data da retirada em Manaus', value: '201' },
  { label: '202 - Placa da carreta responsável pelo transporte', value: '202' },
  { label: '203 - Nome da balsa', value: '203' },
  { label: '204 - Nome do empurrador', value: '204' },
  { label: '205 - Número da frota', value: '205' },
  { label: '206 - Data de chegada em Belém', value: '206' },
  { label: '207 - Data de saída de Belém', value: '207' },
  { label: '208 - Data de chegada na Transportadora', value: '208' },
  { label: '209 - Data de saída da Transportadora', value: '209' },
  { label: '210 - Data de chegada no Porto', value: '210' },
  { label: '211 - Data de saída do Porto', value: '211' },
  { label: '212 - Data de chegada na segunda Transportadora', value: '212' },
  { label: '213 - Data de saída da segunda Transportadora (redespacho)', value: '213' },
]

export const CODIGOS_OBSERVACAO = [
  { label: '00 - Sem Observação', value: '00' },
  { label: '01 - Devolução/recusa total', value: '01' },
  { label: '02 - Devolução/recusa parcial', value: '02' },
  { label: '03 - Aceite/entrega por acordo', value: '03' },
  { label: '04 - Devolução/recusa total com NF devolução emitida pelo destinatário', value: '04' },
  { label: '05 - Devolução/recusa parcial c/ NF devolução emitida pelo destinatário', value: '05' },
]
